import { Typography } from '@mui/material'
import { EmptyIndicator } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'

interface Props {
  plate?: string | null
}
export const TruckVisitPlate = observer(({ plate }: Props) => {
  return <Typography variant='subtitle2'>{plate ?? EmptyIndicator}</Typography>
})
